import {
  getAssociatedTokenAddress,
  getAccount,
  createAssociatedTokenAccountInstruction,
  ASSOCIATED_TOKEN_PROGRAM_ID,
  TOKEN_PROGRAM_ID
} from '@solana/spl-token'
import { PublicKey, Transaction } from '@solana/web3.js'
import type { WalletContextState } from '@solana/wallet-adapter-react'
import { assertPlayWallet } from 'shared/store/play-wallet'
import { connection } from './connection'

export async function getOrCreateAtaFrontend(params: {
  wallet: WalletContextState
  owner: PublicKey
  mint: PublicKey
  ownerIsPda?: boolean
}): Promise<PublicKey> {
  const { wallet, owner, mint, ownerIsPda } = params

  if (!wallet.publicKey) throw new Error('Wallet not connected')
  if (!wallet.signTransaction && !wallet.sendTransaction) {
    throw new Error('Wallet does not support signing transactions')
  }

  const ata = await getAssociatedTokenAddress(
    mint,
    owner,
    ownerIsPda ?? false,
    TOKEN_PROGRAM_ID,
    ASSOCIATED_TOKEN_PROGRAM_ID
  )

  try {
    await getAccount(connection, ata)
    return ata
  } catch {
    const tx = new Transaction().add(
      createAssociatedTokenAccountInstruction(
        wallet.publicKey,
        ata,
        owner,
        mint,
        TOKEN_PROGRAM_ID,
        ASSOCIATED_TOKEN_PROGRAM_ID
      )
    )

    tx.feePayer = wallet.publicKey
    tx.recentBlockhash = (
      await connection.getLatestBlockhash('finalized')
    ).blockhash

    assertPlayWallet(wallet.publicKey.toBase58())
    const signed = await wallet.signTransaction!(tx)
    const sig = await connection.sendRawTransaction(signed.serialize())
    await connection.confirmTransaction(sig, 'confirmed')
    return ata
  }
}
